import React, { useContext } from 'react';
import isNumber from 'lodash/isNumber';

import cypressIds from 'Components/cypress_ids.json';
import { VehicleOriginalPrice } from 'Components/shared/VehicleOriginalPrice/VehicleOriginalPrice';
import { VehicleContext } from 'Context/VehicleContext';
import { applyCypressData } from 'Utilities/helpers';
import useFeatureToggle, { FEATURES } from 'Utilities/hooks/useFeatureToggle';
import { getVehicleStatusFromVehicleState } from 'Utilities/vehicleState';

import styles from './VehiclePrice.module.scss';

type VehiclePriceProps = {
	label: string;
	originalPrice?: string;
	price: string;
	reheatCount?: number;
};

export const VehiclePrice = ({ label, originalPrice, price, reheatCount }: VehiclePriceProps) => {
	const { state } = useContext(VehicleContext) ?? {};

	const status = state && getVehicleStatusFromVehicleState(state);

	const isHideDiscountWhenReheatedEnabled = useFeatureToggle(FEATURES.hideDiscountWhenReheated);
	const shouldHideDiscountWhenReheated = isHideDiscountWhenReheatedEnabled && isNumber(reheatCount);

	return (
		<div
			className={styles.vehiclePriceWrapper}
			data-vehicle-status={status}
			{...applyCypressData(cypressIds.tooltips.vehicleCardStatus)}
		>
			{label ? <span>{label}</span> : null}
			<span className={styles.priceContainer}>
				<span className={styles.price} {...applyCypressData(cypressIds.text.vehiclePriceText)}>
					{price}
				</span>
				{!shouldHideDiscountWhenReheated && originalPrice && <VehicleOriginalPrice price={originalPrice} />}
			</span>
		</div>
	);
};
